/*
  Canonical image-URL resolver. ONE source of truth so images never break
  regardless of how the value was stored in the DB.

  Handles:
    - null / "" / non-string            -> null (component shows a fallback)
    - data: / blob: URIs                -> used as-is (local previews)
    - "/api/uploads/.." (relative)      -> prefixed with the backend origin
    - "/uploads/.." (legacy, no /api)   -> normalised to "/api/uploads/.."
    - absolute URL on OUR app domain    -> rebound to the CURRENT backend
      (fixes images saved with a stale preview / old domain so they keep
       loading on production and vice-versa)
    - genuine external URLs (google,
      stock photos, etc.)               -> used as-is
*/
const API_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function resolveImageUrl(value) {
  if (!value || typeof value !== "string") return null;
  const v = value.trim();
  if (!v) return null;
  if (v.startsWith("data:") || v.startsWith("blob:")) return v;

  // Find an upload path anywhere in the string (covers absolute URLs too).
  const uploadMatch = v.match(/\/(?:api\/)?uploads\/[^\s"'?]+/);

  if (/^https?:\/\//i.test(v)) {
    if (uploadMatch) {
      let path = uploadMatch[0];
      if (path.startsWith("/uploads/")) path = `/api${path}`;
      return `${API_URL}${path}`;
    }
    return v; // genuine external image
  }

  let path = v.startsWith("/") ? v : `/${v}`;
  if (path.startsWith("/uploads/")) path = `/api${path}`;
  return `${API_URL}${path}`;
}

export default resolveImageUrl;
